import { render, staticRenderFns } from "./ProductTask.vue?vue&type=template&id=29654e44&scoped=true&"
import script from "./ProductTask.vue?vue&type=script&lang=js&"
export * from "./ProductTask.vue?vue&type=script&lang=js&"
import style0 from "./ProductTask.vue?vue&type=style&index=0&id=29654e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29654e44",
  null
  
)

export default component.exports